import BookBetService from '../../services/BookBetService';
import { showErrorNotification } from '../../utils/render';
import { getProfile } from './auth';

export const depositVoucher = data => async dispatch => {
    try {
        const {
            data: { info },
        } = await BookBetService.depositVoucher(data);

        if (info.success) {
            dispatch(getProfile());
        }

        return { info };
    } catch (error) {
        console.error(error);
        showErrorNotification(error.response?.data.info.errors[0].reason || 'Something went wrong');

        return { info: { success: false } };
    }
};
